// import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <h1>Bill Pratt</h1>
        <p>
          I am a San Francisco based Engineer, Design Strategist, Junior Full Stack Software Engineer, Project and Portfolio Manager, and Researcher with 11 years of service as a US Army Engineer Officer.
        </p>
        <div class="row">
            <img src="https://i.imgur.com/ZZ2ePfem.jpg" alt="mobe_nsf" class="center md:flex-grow-0"></img>
            <img src="https://i.imgur.com/LkrQ4NTm.jpg" alt="afghanistan" class="center md:flex-grow-0"></img>
        </div>
        <p>
          I like building fullstack websites (I am proficient in Node.js, Express, Mongoose, React, Ruby on Rails, PostgreSQL, JS, HTML, and CSS).  I especially like building my own APIs and tools to enhance my quantitative Design Strategy and Business Consulting practice.
        </p>
        <div>
          <img src="https://i.imgur.com/fjWaC6pm.png" alt="pmd" class="center md:flex-grow-0"></img>
          <a href="https://competent-jepsen-7ab1b3.netlify.app">
            <img src="https://i.imgur.com/xn3ZcLkm.png" alt="run" class="center md:flex-grow-0"/>
          </a>
          <a href="https://brave-einstein-130b44.netlify.app/">
            <img src="https://i.imgur.com/9I1zszUm.png" alt="cas" class="center md:flex-grow-0" />
          </a>
          <a href="https://flamboyant-montalcini-a7afd0.netlify.app/">
            <img src="https://i.imgur.com/fijWCa3m.png" alt="cas" class="center md:flex-grow-0" />
          </a>
        </div>
        <p>
          I also like taking innovative retail concepts from ideas, to models, and to full sized prototypes.
        </p>
        <div>
          <img src="https://i.imgur.com/rSdqzeFm.jpg" alt="pmd" class="center md:flex-grow-0"></img>
          <img src="https://i.imgur.com/TR73iTym.jpg" alt="pbo" class="center md:flex-grow-0"></img>
          <img src="https://i.imgur.com/gY9YvKcm.jpg"alt="run" class="center md:flex-grow-0"></img>
        </div>
        <p>
          I also lead/facilitate design sprints and workshops.  This one was for business leaders at Google.
        </p>
        <div>
          <img src="https://i.imgur.com/FX2L6Ltm.jpg" alt="run" class="center md:flex-grow-0"></img>
          <img src="https://i.imgur.com/vHslUZ2m.jpg" alt="run" class="center md:flex-grow-0"></img>
        </div>
        <p>
          This one was for a unit on Camp Arifjan, Kuwait.
        </p>
        <div>
          <img src="https://i.imgur.com/hPzwninm.jpg" alt="run" class="center md:flex-grow-0"></img>
          <img src="https://i.imgur.com/KysiXmdm.jpg" alt="run" class="center md:flex-grow-0"></img>
        </div>
        <p>
          I also love doing research and presenting.
        </p>
        <div>
          <img src="https://i.imgur.com/QcUR61cm.jpg" alt="run" class="center md:flex-grow-0"></img>
          <img src="https://i.imgur.com/bazyukxm.jpg" alt="run" class="center md:flex-grow-0"></img>
        </div>
        <p>
          I would love to hear about what we can acheive together!
        </p>
        <a href="https://www.linkedin.com/in/william-pratt-california/">
            <img src="https://i.imgur.com/gtbhcjrs.png" alt="cas" class="center md:flex-grow-0" />
          </a>
        <p>
          You can reach me at pratt.pmd@gmail.com
        </p>
      </header>
    </div>
  );
}

export default App;
